import Marionette from "../../shared/marionette-mustache";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import * as Backbone from "backbone-associations";
import {CitelineModel} from "../models/citeline";
import {AppEvents} from "../../app-events";
import {autoinject, transient} from "aurelia-dependency-injection";
import "waypoints/lib/jquery.waypoints";

require("../styles/citeline.less");

const template = require<string>("./citeline.html");
const dom = {
CITELINE_GROUP: ".all-citing-cases-gallery",
CITELINE_REGION: ".citeline-region",
CITELINE_CASE: ".citeline-citing-case",
CITELINE_DOT: ".citeline-dot",
DOCUENT_LINK: ".document-link",
ARROW_LEFT: "#citeline-scroller-left-icon",
ARROW_RIGHT: "#citeline-scroller-right-icon",
};

@backboneViewProperties({
    template: template
})
@autoinject
@transient()
export class CitelineView extends Marionette.ItemView<CitelineModel> {

    private inMotion: boolean;
    private waypointsCreated = false;

    constructor(private appEvents: Backbone.Events, options: any) {
        super(options);
    }

    public onShow() {
        _.delay(() => {
            this.$(".citeline").addClass("engaged");
            this.createParagraphLinks();
            if (this.model.CasesToShowCount < 2 && !this.inCompactMode()) {
                $(dom.ARROW_RIGHT).hide();
            }
        }, 50);
        _.delay(() => { // 50ms not enough delay for this to funciton properly
            if (this.inCompactMode()) {
                this.setupPositionCounter();
            } else {
                this.listenTo(this.model.DocumentHolder, "change:Compact", this.compactChanged);
            }
        }, 500);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click ${dom.CITELINE_CASE}`] = this.caseClick;
        events[`click ${dom.CITELINE_DOT}`] = this.dotClick;
        events[`click ${dom.DOCUENT_LINK}`] = this.documentLinkClick;

        // below events are IE 9/10 fix only - These elements have "pointer-events: none" so any other browser will register a click on element below instead
        events[`click ${dom.ARROW_LEFT}`] = this.leftArrowClick;
        events[`click ${dom.ARROW_RIGHT}`] = this.rightArrowClick;
        return events;
    }
    private compactChanged(model, prop) {
        if (this.inCompactMode()) {
            if (!this.waypointsCreated) {
                this.setupPositionCounter();
            }
            this.$(".citing-cases-current").text(1);
        } else {
            const num = $(`${dom.CITELINE_CASE}.current`).data("number");
            this.$(".citing-cases-current").text(num);
        }
    }
    private setupPositionCounter() {

        if (this.$(dom.CITELINE_CASE + ":visible").length > 250) {
            // if there are too many cases, waypoints will crash the browser
            // a lack of live position counter isn't a disaster, especially in these fringe cases
            return;
        }

        const citelineView = this; // Need reference to this inside handler function
        const firstCase =  this.$(dom.CITELINE_CASE).first();
        const subsequentCases = this.$(dom.CITELINE_CASE).slice(1);

        _.delay(() => {

            firstCase.waypoint({ // Special case for the first case - Scrolling to the very top should always set the counter to 1.
                handler: (direction) => {
                    if (!citelineView.inCompactMode() ) {
                        return;
                    }
                    this.$(".citing-cases-current").text(1);
                },
                context: this.$(".all-citing-cases-gallery").first(),
                offset: -25
            });

            subsequentCases.waypoint({ // if we're scrolling down and the top of an element hits 40% of the way down the container, call this one active
                handler: function(direction) {
                    if (!citelineView.inCompactMode() || direction !== "down") {
                        return;
                    }
                    const el = $(this.element); // "this" is the waypoint instance as we're inside a "function" rather than a lambda which inherits parent "this"
                    const num = el.data("number");
                    citelineView.$(".citing-cases-current").text(num);
                },
                context: this.$(".all-citing-cases-gallery").first(),
                offset: "40%"
            });

            subsequentCases.waypoint({ // If we're scrolling up and the top of an element hits 60% down of the container, call the previous one active
                handler: function(direction) {
                    if (!citelineView.inCompactMode() || direction !== "up") {
                        return;
                    }
                    const el = $(this.element); // "this" is the waypoint instance as we're inside a "function" rather than a lambda which inherits parent "this"
                    let num = el.data("number");
                    if (num === 1) {
                        num = 2; // Prevent setting it to 0 at very top
                    }
                    citelineView.$(".citing-cases-current").text(num - 1);
                },
                context: this.$(".all-citing-cases-gallery").first(),
                offset: "60%"
            });
            this.waypointsCreated = true;

        }, 1000);

    }

    // IE 9/10 fix only - These elements have "pointer-events: none" so any other browser will register a click on element below instead
    private leftArrowClick() {
        if (this.inMotion) {
            return;
        }
        this.inMotion = true;
        this.focusCase(this.$(`${dom.CITELINE_CASE}.previous`));
    }
    // IE 9/10 fix only - These elements have "pointer-events: none" so any other browser will register a click on element below instead
    private rightArrowClick() {
        if (this.inMotion) {
            return;
        }
        this.inMotion = true;
        this.focusCase(this.$(`${dom.CITELINE_CASE}.next`));
    }

    private dotClick(e: JQueryMouseEventObject) {
        const targetNum = this.$(e.currentTarget).attr("data-num");
        const targetCase = this.$(`.citeline-citing-case[data-number='${targetNum}']`);
        this.focusCase(targetCase);
    }

    private caseClick(e: JQueryMouseEventObject) {
        const $target = this.$(e.currentTarget);
        if ($target.hasClass("current")) {
            return;
        }
        if (this.inMotion) {
            return;
        }
        if (!$target.hasClass("document-link")) {
            this.inMotion = false;
        }
        this.inMotion = true;
        this.focusCase($target);
    }

    private inCompactMode() {
        return this.model.DocumentHolder.Compact;
    }

    private focusCase($target) {

        if (this.inCompactMode()) {
            this.inMotion = false;
        } else {
            this.$(".citeline-citing-case").bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", () => {
                this.inMotion = false;
            });
        }
        const $next = $target.next(dom.CITELINE_CASE);
        const $previous = $target.prev(dom.CITELINE_CASE);
        const $next$next = $next.next(dom.CITELINE_CASE);
        const $previous$previous = $previous.prev(dom.CITELINE_CASE);
        this.$(".citeline-citing-case").removeClass("current previous next outside-left outside-right gone");
        const num = $target.attr("data-number");
        this.$(".citing-cases-current").text(num);
        this.$(".citeline-dot").removeClass("current");
        this.$(`.citeline-dot[data-num='${num}']`).addClass("current");
        $target.addClass("current");
        setTimeout(() => {
            this.$(".citeline-citing-case").not($target).removeClass("front");
            $target.addClass("front");
        }, this.inMotion ? 300 : 0);

        if ($next.length) {
            $next.addClass("next");
            this.$(dom.ARROW_RIGHT).show();
        } else {
             this.$(dom.ARROW_RIGHT).hide();
        }
        if ($previous.length) {
            $previous.addClass("previous");
            this.$(dom.ARROW_LEFT).show();
        } else {
            this.$(dom.ARROW_LEFT).hide();
        }
        if ($previous$previous.length) {
            $previous$previous.addClass("outside-left");
        }
        if ($next$next.length) {
            $next$next.addClass("outside-right");
        }
        $target.prevAll().not($previous).not($previous$previous).addClass("gone");
        $target.nextAll().not($next).not($next$next).addClass("gone");
    }

    private documentLinkClick(e: JQueryMouseEventObject) {
        if (!this.$(e.currentTarget).parents(".citeline-citing-case").hasClass("current") && !this.inCompactMode()) {
            this.inMotion = false;
            return false;
        }
    }

    private createParagraphLinks() {
        this.$(".para-group").each((idx, element) => {
            const docUrl = $(element).parent().attr("data-url").replace("overview", "fulltext-judgment");
            const paraNum = $(element).attr("data-num");
            const fullUrl = `${docUrl}/${paraNum}`;
            const link = $(`<a href="${fullUrl}" class="document-link citeline-document-link">Go to paragraph <i class="fa fa-chevron-right" aria-hidden="true"></i></a>"`);
            this.$(element).append(link);
            link.click(() => {
                this.inMotion = false;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/citeline.ts